<template>
  <div class="tour-view main">
    <div
      id="tournav"
      class="flex flex-row justify-center w-full items-center nav bg-white z-10 shadow-lg flex-no-wrap"
    >
      <a
        @click="submitEventToData($event)"
        alt="home"
        :id="`${personaPrefix}SagePeopleLogo`"
        :href="sagePeoplePage"
        class="w-6/12 md:w-10/12 ml-1 md:ml-6 main-logo-tour"
      >
        <img width="140" src="../assets/img/sage-logo-black.png" />
      </a>
      <a
        @click="submitEventToData($event)"
        :href="gateId"
        :id="`${personaPrefix}BookaDemo_TopRight`"
        class="tmp-btn-tr text-white text-sm mr-1 md:mr-6"
        >{{ $t(`general.book`) }}
      </a>
    </div>
    <div class="flex flex-row flex-wrap justify-between">
      <div class="w-10/12 main-view-wrapper flex-1 items-center justify-center">
        <!-- //!Mobile only Title section -->
        <div class="pt-6 px-6 block md:hidden">
          <h4
            style="animation-delay: 1.5s"
            class="text-white text-3xl leading-tight"
          >
            {{
              translatePayload(
                views[selectedPersonaIndex].personaViews[personaViewIndex].title
              )
            }}
          </h4>
        </div>
        <div
          @click="overview = !overview"
          class="px-6 mt-6 block md:hidden overflow-hidden overview cursor-pointer"
          :class="{ 'h-auto': overview }"
        >
          <div class="flex flex-row full-w">
            <div class="heading self-cente text-white flex-1 o-text pt-1 pb-4">
              {{ $t("general.mobileOverview") }}
            </div>
            <div class="self-center items-center pb-4">
              <svg
                v-if="!overview"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="8"
                viewBox="0 0 14 8"
              >
                <path
                  id="icon-chevron-down"
                  d="M7,8a1.5,1.5,0,0,1-.88-.448L.293,1.7A.988.988,0,0,1,.3.291a1.015,1.015,0,0,1,1.418,0L7,5.8,12.285.287a1.015,1.015,0,0,1,1.418,0,.988.988,0,0,1,0,1.408L7.877,7.552A1.442,1.442,0,0,1,7,8Z"
                  fill="#fff"
                />
              </svg>
              <svg
                v-if="overview"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="8"
                viewBox="0 0 14 8"
              >
                <path
                  id="icon-chevron-up"
                  d="M7,0a1.5,1.5,0,0,0-.88.448L.293,6.3a.988.988,0,0,0,0,1.408,1.015,1.015,0,0,0,1.418,0L7,2.2l5.288,5.516a1.015,1.015,0,0,0,1.418,0,.988.988,0,0,0,0-1.408L7.877.448A1.442,1.442,0,0,0,7,0Z"
                  fill="#00000"
                />
              </svg>
            </div>
          </div>
          <p style="animation-delay: 3s" class="text-white font-thin pb-6">
            {{
              translatePayload(
                views[selectedPersonaIndex].personaViews[personaViewIndex].body
              )
            }}
          </p>
        </div>
        <!-- //!-------- -->

        <MainPage
          :key="pageViewIndex"
          :personaDataAction="personaDataAction"
          :areWeTracking="areWeTracking"
          @countReached="notifyPopUp"
          :welcomePos="welcomePos"
          class="comp relative md:absolute overflow-auto md:overflow-visible pt-0 md:pt-6 pb-12 md:pb-5 px-0 md:px-6"
          @navigateTo="pageViewIndex = $event"
          :hotspots="
            views[selectedPersonaIndex].personaViews[pageViewIndex].hotspots
          "
          :pageImages="
            views[selectedPersonaIndex].personaViews[pageViewIndex].images
          "
          :submitEventToData="submitEventToData"
          :mediaFolderUrl="`../assets/${views[selectedPersonaIndex].firstName}${views[selectedPersonaIndex].lastName}/`"
        >
        </MainPage>

        <div
          class="pb-4 pt-4 px-6 flex md:hidden flex-row justify-center fixed bottom-0 left-0 items-center p-mobile"
        >
          <a
            @click="submitEventToData($event)"
            alt="home"
            class="home-b"
            :href="sagePeopleHomePage"
            :id="`${personaPrefix}HomeButton`"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="pr-2"
              width="36"
              height="36"
              viewBox="0 0 16 16"
            >
              <path
                id="icon-house"
                d="M10,16V11H6v5H3a1,1,0,0,1-1-1l0-4.4,6-6,6,5.893L14,15a1,1,0,0,1-1,1ZM8,2.726,1.3,9.3,0,8.1,8,0l8,8.1L14.7,9.3Z"
                fill="#fff"
              />
            </svg>
          </a>
          <!-- <router-link to="/" :id="`${personaPrefix}OliverBenson`" class="persona-cta-tour"> -->
          <div
            v-for="persona in personasArray"
            :key="persona.index"
            :id="`${personaPrefix}${persona.firstName}${persona.lastName}`"
            class="switch-icons px-2 py-2 persona-cta-tour"
            :class="{ active: selectedPersonaIndex == persona.index }"
            @click="switchPersona(persona.index), submitEventToData($event)"
          >
            <div @mouseover="pIcon = persona.index" @mouseleave="pIcon = null">
              <img
                :src="persona.image"
                :alt="`${persona.personaDataAction} profile`"
                width="65"
              />
            </div>
            <!-- //!-------- -->
            <!-- //!tooltip hover -->
            <transition name="zoom">
              <div
                style="animation-duration: 0.2s; animation-delay: 0.1s"
                class="tt-wrapper"
                v-if="pIcon === persona.index"
              >
                <p class="p-2 font-thin text-xs">
                  <b>{{
                    translatePayload(`homePage.${persona.i18nKey}Name`)
                  }}</b>
                  <br />
                  {{ translatePayload(`homePage.${persona.i18nKey}Type`) }}
                </p>
              </div>
            </transition>
          </div>
          <!-- </router-link> -->
          <!-- </router-link> -->
        </div>
      </div>

      <!-- Right side navigation on desktop -->
      <div class="w-2/12 side-bar-wrapper flex-col hidden md:flex">
        <!-- tour navigation row-->
        <div
          class="pb-4 pt-4 px-6 hidden md:flex flex-row justify-center items-center"
        >
          <a
            @click="submitEventToData($event)"
            alt="Home"
            class="home-b"
            :href="sagePeopleHomePage"
            :id="`${personaPrefix}HomeButton`"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="pr-2"
              width="36"
              height="36"
              viewBox="0 0 16 16"
            >
              <path
                id="icon-house"
                d="M10,16V11H6v5H3a1,1,0,0,1-1-1l0-4.4,6-6,6,5.893L14,15a1,1,0,0,1-1,1ZM8,2.726,1.3,9.3,0,8.1,8,0l8,8.1L14.7,9.3Z"
                fill="#fff"
              />
            </svg>
          </a>
          <div
            v-for="persona in personasArray"
            :key="persona.index"
            :id="`${personaPrefix}${persona.firstName}${persona.lastName}`"
            class="switch-icons px-2 py-2 persona-cta-tour"
            :class="{ active: selectedPersonaIndex == persona.index }"
            @click="switchPersona(persona.index), submitEventToData($event)"
          >
            <div @mouseover="pIcon = persona.index" @mouseleave="pIcon = null">
              <img
                :src="persona.image"
                :alt="`${persona.personaDataAction} profile`"
                style="width: 100%; max-height: 60px"
                width="65"
              />
            </div>
            <transition name="zoom">
              <div
                style="animation-duration: 0.01s; animation-delay: 0.1s"
                class="tt-wrapper"
                v-if="pIcon === persona.index"
              >
                <p class="p-2 font-thin text-xs">
                  <b class="font-bold">{{
                    translatePayload(`homePage.${persona.i18nKey}Name`)
                  }}</b>
                  <br />
                  {{ translatePayload(`homePage.${persona.i18nKey}Type`) }}
                </p>
              </div>
            </transition>
          </div>
        </div>
        <!-- END tour navigation row-->

        <!-- Tour navigation header-->
        <div class="side-title-inner-wrapper p-6">
          <transition name="slideRight">
            <h4
              style="animation-delay: 1.5s"
              class="text-white text-3xl leading-tight whitespace-pre-line"
            >
              {{
                translatePayload(pageTitle)
              }}
            </h4>
          </transition>
        </div>
        <!--END tour navigation header-->

        <!-- Tour navigation paragraph-->
        <div class="side-text-inner-wrapper pb-6 px-6">
          <p
            style="animation-delay: 3s"
            class="text-white font-thin whitespace-pre-line"
          >
            {{
              translatePayload(pageBody)
            }}
          </p>
        </div>
        <!--END tour navigation paragraph-->

        <!-- Tour navigation bottom tooltips-->
        <div class="key-wrapper flex w-full flex-row justify-start py-2 px-6">
          <div class="flex py-2 pr-4 justify-start items-center">
            <div class="tooltip relative cursor-default"></div>
            <p class="text-white text-xs pl-4">
              {{ translatePayload(`general.keyNav`) }}
            </p>
          </div>
          <div class="flex py-2 justify-start items-center">
            <div
              class="dialog relative cursor-default"
              style="border: 1px solid black"
            >
              <svg
                style="z-index: 9999"
                xmlns="http://www.w3.org/2000/svg"
                width="7.196"
                height="8.103"
                viewBox="0 0 7.196 8.103"
              >
                <g id="uniE95F" transform="translate(0 -0.011)">
                  <path
                    id="Path"
                    d="M0,1.03A1.118,1.118,0,0,1,.032.757.7.7,0,0,1,.144.517.981.981,0,0,1,.768.037a.924.924,0,0,1,.768.112L6.689,3.174A1.015,1.015,0,0,1,7.161,4.31a.953.953,0,0,1-.472.624L1.536,7.959a1.209,1.209,0,0,1-.24.1.907.907,0,0,1-.272.04A.976.976,0,0,1,.3,7.8a1,1,0,0,1-.3-.72Z"
                    transform="translate(0 0.011)"
                    fill="#00000"
                  />
                </g>
              </svg>
            </div>
            <p class="text-white text-xs pl-4">Video</p>
          </div>
        </div>
        <div class="flex w-full flex-row justify-start py-2 px-6">
          <div class="flex pr-12 justify-start items-center">
            <div
              class="dialog relative cursor-default"
              style="border: 1px solid black"
            >
              <p style="z-index: 9999; color: black">i</p>
            </div>
            <p class="text-white text-xs pl-4">Info</p>
          </div>
          <div class="flex justify-start items-center">
            <div
              class="dialog relative cursor-default"
              style="border: 1px solid black"
            >
              <p style="z-index: 9999; color: black">+</p>
            </div>
            <p class="text-white text-xs pl-4">Interactive</p>
          </div>
        </div>
        <!--END tour navigation bottom tooltips-->

        <div class="flex justify-start items-center pt-6 pb-4 px-6">
          <button
            :id="`${personaPrefix}Homepage_KeyInfo`"
            @click="
                setWelcome(true),
                (welcomePos = 1),
                submitEventToData($event)
            "
            class="tmp-btn outline text-white text-xs view-cta-tour"
          >
            View instructions
          </button>
        </div>
      </div>
      <!-- END Right side navigation on desktop-->
    </div>

    <transition name="fade">
      <div
        v-if="welcome"
        class="welcome-modal-wrapper flex justify-center items-center"
      >
        <transition name="zoom">
          <div
            :key="welcomeMessages[welcomePos].index"
            style="animation-duration: 0.2s"
            v-hotspot="{
              position: welcomeMessages[welcomePos].position,
              top: welcomeMessages[welcomePos].top,
              left: welcomeMessages[welcomePos].left,
              right: welcomeMessages[welcomePos].right,
            }"
            class="welcome-modal-inner-wrapper"
          >
            <div
              class="pulsing"
              :class="{
                personaimage: welcomeMessages[welcomePos].persona,
                dialog: welcomeMessages[welcomePos].dialog,
                tooltip: welcomeMessages[welcomePos].tooltip,
                copy: welcomeMessages[welcomePos].copy,
              }"
            >
              <svg
                v-if="welcomeMessages[welcomePos].dialogPlus"
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
              >
                <path
                  id="icon-plus"
                  d="M7,1A1,1,0,1,0,5,1V5H1A1,1,0,1,0,1,7H5v4a1,1,0,1,0,2,0V7h4a1,1,0,1,0,0-2H7Z"
                  fill="#00000"
                />
              </svg>
              <svg
                v-if="welcomeMessages[welcomePos].play"
                xmlns="http://www.w3.org/2000/svg"
                width="7.196"
                height="8.103"
                viewBox="0 0 7.196 8.103"
              >
                <g id="uniE95F" transform="translate(0 -0.011)">
                  <path
                    id="Path"
                    d="M0,1.03A1.118,1.118,0,0,1,.032.757.7.7,0,0,1,.144.517.981.981,0,0,1,.768.037a.924.924,0,0,1,.768.112L6.689,3.174A1.015,1.015,0,0,1,7.161,4.31a.953.953,0,0,1-.472.624L1.536,7.959a1.209,1.209,0,0,1-.24.1.907.907,0,0,1-.272.04A.976.976,0,0,1,.3,7.8a1,1,0,0,1-.3-.72Z"
                    transform="translate(0 0.011)"
                    fill="#00000"
                  />
                </g>
              </svg>
              <span v-if="welcomeMessages[welcomePos].infoIcon">i</span>
            </div>

            <p
              class="heading pb-4 pt-6 pr-6"
              :class="welcomeMessages[welcomePos].first ? 'pl-6' : 'pl-24'"
            >
              {{ translatePayload(welcomeMessages[welcomePos].title) }}
            </p>
            <p class="px-6 pb-4">
              {{ translatePayload(welcomeMessages[welcomePos].body) }}
            </p>
            <div class="flex flex-row justify-end full-w">
              <button
                tabindex="0"
                :id="`${personaPrefix}Tour_Skip`"
                @click="
                    setWelcome(false),
                    submitEventToData($event)
                "
                class="tmp-btn ghost self-end text-xs skip-cta-tour"
              >
                {{ translatePayload(`tour.welcomeSkip`) }}
              </button>
              <button
                tabindex="0"
                @keyup.enter="calculateWelcome(), submitEventToData($event)"
                @click="calculateWelcome(), submitEventToData($event)"
                :id="`${personaPrefix}${welcomeMessages[welcomePos].id}`"
                class="tmp-btn text-white self-end text-sm next-cta-tour"
              >
                {{ translatePayload(welcomeMessages[welcomePos].ctaText) }}
              </button>
            </div>
          </div>
        </transition>
      </div>
    </transition>

    <transition name="slideUp">
      <div
        v-if="notify"
        class="border-t-4 notify rounded-b text-teal-900 px-4 py-4 shadow-md absolute bottom-0 left-2"
        role="alert"
      >
        <div class="flex flex-wrap">
          <div class="py-2">
            <svg
              class="fill-current h-6 w-6 text-teal-500 mr-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"
              />
            </svg>
          </div>
          <div>
            <p class="font-bold">{{ translatePayload(`tour.popupTitle`) }}</p>
            <p class="text-sm">{{ translatePayload(`tour.popupBody`) }}</p>
          </div>
          <div>
            <a
              @click="submitEventToData($event)"
              :href="gateId"
              :id="`${personaPrefix}BookaDemo_PopUp`"
              class="tmp-btn text-white text-sm mr-1 md:ml-6"
              >{{ translatePayload(`general.book`) }}</a
            >
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import views from "../config/tour/index";
import personasArray from "../config/home/index";
import welcomeMessages from "../config/tour/welcomeMessages";
import MainPage from "../components/MainPage.vue";
export default {
  name: "Tour",
  components: {
    MainPage,
  },
  data: function () {
    return {
      views,
      personasArray,
      welcomeMessages,
      sagePeopleHomePage:
        "https://www.sage.com/en-gb/sage-business-cloud/people/interactive-product-tour/",
      welcomePos: 0,
      personaViewIndex: 0,
      overview: false,
      pIcon: null,
      notifyCount: 0,
      notify: false,
      pageViewIndex: 0,
    };
  },
  computed: {
    areWeTracking() {
      return this.$store.state.areWeTracking;
    },
    selectedPersonaIndex() {
      return this.$store.state.selectedPersonaIndex;
    },
    personaPrefix() {
      return this.$store.state.personaPrefix;
    },

    sagePeoplePage() {
      return this.$store.state.sagePeoplePage;
    },
    gateId() {
      return this.$store.state.gateId;
    },
    personaDataAction() {
      return this.$store.state.personaDataAction;
    },
    welcome() {
      return this.$store.state.welcome;
    },
    pageTitle() {
      return this.views[this.selectedPersonaIndex].personaViews[this.pageViewIndex].title
    },
    pageBody() {
      return this.views[this.selectedPersonaIndex].personaViews[this.pageViewIndex].body
    }
  },
  methods: {
    setPersonaDataAction(payload) {
      this.$store.state.personaDataAction = payload;
    },
    translatePayload(payload) {
      return this.$i18n.t(payload);
    },
    setWelcome(payload){
      this.$store.state.welcome = payload
    },
    calculateWelcome() {
      this.$nextTick(() => {
        if (this.welcomePos < this.welcomeMessages.length - 1) {
          this.setWelcome(true)
          this.welcomePos++;
        } else {
          this.setWelcome(false)
        }
      });
    },
    submitEventToData(event) {
      if (this.areWeTracking) {
        console.log("We are tracking");
        // eslint-disable-next-line
        utag.link({
          event_category: "Interactive Tool",
          event_action: this.personaDataAction,
          event_label: event.target.id,
        });
      } else {
        console.log("We are NOT tracking");
      }
    },
    switchPersona(payload) {
      this.$store.state.selectedPersonaIndex = payload;
      this.$router.history.push("/");
    },
    notifyPopUp() {
      if (this.notifyCount == 13 && this.areWeTracking) {
        this.notify = true;
        setTimeout(() => {
          this.notify = false;
        }, 10000);
      }
      this.notifyCount++;
    },
  },
};
</script>
<style lang="scss" scoped>
html body {
  overflow-y: hidden !important;
}

.main-logo-tour img {
  max-height: 50px;
  width: auto;
}

.tmp-btn-tr {
  background-color: #00815d;
  border-radius: 0;
  font-weight: normal;
  text-align: center;
  padding: 8px 25px;
  display: inline-block;
  font-size: 18px;
  min-width: initial;
  cursor: pointer;

  &:focus {
    outline: 5px solid #ffb500;
  }

  &.dark {
    background-color: #19485c;
  }
}

.nav {
  position: fixed;
  top: 0;
  left: 0;
  height: 60px;
  border-bottom: 1px solid #f1f1f1;
}

.notify {
  background: #ffffff;
  border-color: #00a376;
}

.tt-wrapper {
  position: absolute;
  bottom: -60px;
  left: -5px;
  width: 80px;
  background: #ffffff;
  border-radius: 2px;

  & p {
    line-height: 14px;
  }
}

*:focus {
  outline: none;
}

.tmp-btn {
  background-color: #00815d;
  border-radius: 0;
  font-weight: normal;
  text-align: center;
  padding: 15px 25px;
  display: inline-block;
  min-width: initial;
  cursor: pointer;

  &:focus {
    outline: 5px solid #ffb500;
  }

  &.ghost {
    background-color: #ffffff;
  }

  &.outline {
    background: white;
    border: 1px solid white;
    padding: 5px 10px;
    width: 100%;
    color: #19485c !important;
  }

  &.green {
    background-color: #00a376;
    border-radius: 0;
    font-weight: normal;
    text-align: center;
    padding: 10px 25px;
    display: inline-block;
    font-size: 18px;
    min-width: initial;
    cursor: pointer;

    &.dark {
      background-color: #19485c;
    }
  }
}

.welcome-modal-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 400;
  background: #000000b0;

  & .welcome-modal-inner-wrapper {
    width: 100%;
    max-width: 400px;
    box-shadow: 0 10px 40px 0 rgba(0, 20, 29, 0.04),
      0 50px 80px 0 rgba(0, 20, 29, 0.1);
    background: #ffffff;
    position: absolute;
  }
}

// .main {
//   // margin-top: 60px;
// }

.side-bar-wrapper {
  height: calc(100vh - 60px);
  // height: 100vh;  // height: 100vh;
  margin-top: 60px;
  background-color: #000000;
  min-width: 200px;
  position: relative;
  border-left: 1px solid rgba(255, 255, 255, 0.178);
  transition: all 0.2s ease;
}

.switch-icons {
  cursor: pointer;
  position: relative;

  &.active {
    transform: scale(1);
    border: 1px solid white;
    animation: border 5s linear infinite;
    box-shadow: 0 5px 5px 0 rgba(0, 20, 29, 0.2),
      0 10px 10px 0 rgba(0, 20, 29, 0.1);
  }
}

.side-title-inner-wrapper {
  border-top: 1px solid rgba(255, 255, 255, 0.178);
}

.side-text-inner-wrapper {
  overflow-y: auto;
  position: relative;
  height: 80%;
}

.key-wrapper {
  border-top: 1px solid rgba(255, 255, 255, 0.178);
}

.main-view-wrapper {
  height: 100%;
  overflow-y: auto;
  position: relative;
  height: calc(100vh - 60px);
  margin-top: 60px;
  // height: 100vh;
  background: #000000;
}

.tooltip {
  height: 23px;
  width: 23px;
  background: #ce0058;
  border-radius: 50%;
  cursor: pointer;
  opacity: 1;
  box-shadow: 0 5px 5px 0 rgba(0, 20, 29, 0.2),
    0 10px 10px 0 rgba(0, 20, 29, 0.1);
  position: absolute;
  left: 25px;
  top: 26px;

  &::before {
    content: "";
    height: 25px;
    width: 25px;
    background: #ce0058;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    top: 50%;
    left: 50%;
  }

  &::after {
    content: "";
    height: 25px;
    width: 25px;
    background: #ce0058;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    top: 50%;
    left: 50%;
  }

  &.pulsing::after {
    animation: pulse infinite 2s linear;
    animation-delay: 1.9s;
  }

  &.relative {
    position: relative;
    top: 0;
    left: 0;
  }
}

.pulsing::before {
  animation: pulse infinite 2s linear;
}

.personaimage {
  height: 25px;
  width: 30px;
  background: url("../assets/img/Persona1.jpg");
  background-size: cover;
  position: absolute;
  left: 25px;
  top: 25px;
}

.copy {
  height: 30px;
  width: 30px;
  background: #003449;
  background-size: cover;
  position: absolute;
  left: 25px;
  top: 25px;
  display: flex;
  justify-content: center;
  align-items: center;

  &:after {
    content: "C";
    color: white;
  }
}

.dialog {
  height: 25px;
  width: 25px;
  background: #ffb500;
  border-radius: 5%;
  transition: all 0.1s linear;
  cursor: pointer;
  border: 1px solid black;
  box-shadow: 0 5px 5px 0 rgba(0, 20, 29, 0.2),
    0 10px 10px 0 rgba(0, 20, 29, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 25px;
  top: 25px;

  // &::after {
  //   content: "+";
  //   color: white;
  //   position: relative;
  // }
  &::before {
    content: "";
    height: 25px;
    width: 25px;
    background: #ffb500;
    transform: translate(-50%, -50%);
    position: absolute;
    top: 50%;
    left: 50%;
  }

  &.relative {
    position: relative;
    top: 0;
    left: 0;
    border: none;
  }
}

@keyframes pulse {
  0% {
    height: 0px;
    width: 0px;
    opacity: 1;
  }

  50% {
    height: 60px;
    width: 60px;
    opacity: 0;
  }

  100% {
    height: 0px;
    width: 0px;
    opacity: 0;
  }
}

@-webkit-keyframes pulse {
  0% {
    height: 0px;
    width: 0px;
    opacity: 1;
  }

  50% {
    height: 60px;
    width: 60px;
    opacity: 0;
  }

  100% {
    height: 0px;
    width: 0px;
    opacity: 0;
  }
}

@media screen and (max-width: 750px) {
  .welcome-modal-inner-wrapper {
    position: absolute !important;
    top: auto !important;
    left: auto !important;
  }

  .overview {
    background: #00a376;
    height: 35px;
  }

  .p-mobile {
    background: #003449bb;
    width: 100%;
  }
}
</style>
